import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { RotateCw, MapPinned } from "lucide-react";
import { TOURS, rever } from "../tour";

/**
 * Ajuda → "Rever tutoriais": lista os tours do PAPEL do usuário com botão
 * Rever — pede para o tour daquela tela rodar mais uma vez nesta sessão e
 * navega até ela (respeitando as mesmas regras de momento). A marca de "já
 * viu" do servidor continua lá: depois disso ele não volta sozinho.
 */
export default function ReverTutoriais() {
  const navigate = useNavigate();
  const usuario = useMemo(() => {
    try { return JSON.parse(localStorage.getItem("user") || "null"); } catch { return null; }
  }, []);

  const meusTours = TOURS.filter(
    (t) => !t.papeis?.length || t.papeis.includes(usuario?.role)
  );
  if (!meusTours.length) return null;

  return (
    <div className="bg-card rounded-xl border shadow-sm p-5">
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
          <MapPinned className="w-5 h-5 text-primary" />
        </div>
        <div className="flex-1 min-w-0">
          <h2 className="font-semibold text-base">Rever tutoriais</h2>
          <p className="text-sm text-muted-foreground mt-1 mb-3">
            O passo a passo que aparece na primeira visita de cada tela. Reveja
            quando quiser — ele roda de novo uma única vez.
          </p>
          <div className="space-y-2">
            {meusTours.map((t) => (
              <div key={t.tela} className="flex items-center justify-between gap-3 py-2 px-3 rounded-lg bg-muted/40">
                <span className="text-sm font-medium">{t.titulo}</span>
                <button
                  onClick={() => { rever(t.tela); navigate(t.rota); }}
                  className="min-h-[36px] px-3 rounded-lg text-xs font-semibold bg-primary/10 text-primary hover:bg-primary/20 transition-colors flex items-center gap-1.5"
                >
                  <RotateCw className="w-3.5 h-3.5" /> Rever
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
